


export const getComplaintandIncidentLabels = (assetResponse, langCode) => {
    let complaintIncidentMapping = [];
    const complaints = Array.isArray(assetResponse?.complaints) ? assetResponse.complaints : [];
    complaints.forEach((complaint) => {
        let complaintLanguageLabel = null;
        if (Array.isArray(complaint.complaintLabels)) {
            complaint.complaintLabels.forEach((complaintLabel) => {
                if (complaintLabel.languageCode === langCode) {
                    complaintLanguageLabel = complaintLabel;
                }
            });
        }
        let incidentLabelsLanguage = [];
        if (Array.isArray(complaint.incidentTypes)) {
            complaint.incidentTypes.forEach((incidentLabel) => {
                if (Array.isArray(incidentLabel.incidentTypeLabels)) {
                    incidentLabel.incidentTypeLabels.forEach((incidentTypeLabel) => {
                        if (incidentTypeLabel.languageCode === langCode) {
                            incidentLabelsLanguage.push({
                                incidentId: incidentLabel.incidentTypeId,
                                incidentTypeLabel: incidentTypeLabel.label,
                                ...(incidentLabel.isVandalismEnabled === true ? { isVandalismEnabled: true } : {})
                            });
                        }
                    });
                }
            });
        }
        if (complaintLanguageLabel) {
            complaintIncidentMapping.push({
                complaintLabel: complaintLanguageLabel.label,
                value: {
                    complaintId: complaint.complaintId,
                    incidentTypeLabels: incidentLabelsLanguage
                }
            });
        }
    });
    return complaintIncidentMapping;
}


export const filterIncidentsFromArray = (complaintIncidentMappingState, checkComplaint) => {
    let incidentsLabelsArray = [];
    if (Array.isArray(complaintIncidentMappingState)) {
        complaintIncidentMappingState.forEach((complaintIncident) => {
            if (complaintIncident.complaintLabel === checkComplaint && Array.isArray(complaintIncident.value?.incidentTypeLabels)) {
                complaintIncident.value.incidentTypeLabels.forEach((incident) => {
                    incidentsLabelsArray.push(incident);
                });
            }
        });
    }
    return incidentsLabelsArray;
}